import dayjs from "dayjs";
var calendar = require("dayjs/plugin/calendar");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);
const obj = {
  currencyFormat: (number = "") => {
    return new Intl.NumberFormat("en-IN", {}).format(number);
  },
  dateFormat: (date, timeZone) => {
    var convertedDate = new Date(date).toLocaleString(undefined, {
      timeZone: timeZone ? timeZone : "Asia/Kolkata",
    });

    return convertedDate.toString();
  },
  // msgDateFormat: (date, timeZone) => {
  //   var convertedDate = new Date(date).toLocaleDateString(undefined, {
  //     timeZone: timeZone ? timeZone : "Asia/Kolkata",
  //   });
  //   return convertedDate.toString();
  // },
  msgDateFormat: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "DD.MM.YYYY",
    });
  },
  betCheckObj: {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  },
  msgDateFormatNew: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "DD/MM/YYYY",
      nextDay: "DD/MM/YYYY",
      nextWeek: "DD/MM/YYYY",
      lastDay: "DD/MM/YYYY",
      lastWeek: "DD/MM/YYYY",
      sameElse: "DD/MM/YYYY",
    });
  },
  msgDateFormatTime: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "h:mm A",
      nextDay: "h:mm A",
      nextWeek: "h:mm A",
      lastDay: "h:mm A",
      lastWeek: "h:mm A",
      sameElse: "h:mm A",
    });
  },
  matchDateTime: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "[Today] h:mm A", // The same day ( Today at 2:30 AM )
      nextDay: "[Tomorrow] h:mm A", // The next day ( Tomorrow at 2:30 AM ) [Tomorrow at] h:mm A
      nextWeek: "h:mm MMM DD", // The next week ( Sunday at 2:30 AM )
      sameElse: "h:mm MMM DD", // Everything else ( 17/10/2011 )
    });
  },
  matchDateTimeDetail: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "DD MMM YYYY | h:mm A", // The same day ( Today at 2:30 AM )
      nextDay: "DD MMM YYYY | h:mm A", // The next day ( Tomorrow at 2:30 AM ) [Tomorrow at] h:mm A
      nextWeek: "DD MMM YYYY | h:mm A", // The next week ( Sunday at 2:30 AM )
      lastDay: "DD MMM YYYY | h:mm A", // The day before ( Yesterday at 2:30 AM )
      lastWeek: "DD MMM YYYY | h:mm A", // Last week ( Last Monday at 2:30 AM )
      sameElse: "DD MMM YYYY | h:mm A", // Everything else ( 17/10/2011 )
    });
  },
  marketStatus: (s) => {
    var status = "";
    switch (s) {
      case 1:
        status = "Open";
        break;
      case 2:
        status = "In Active";
        break;
      case 3:
        status = "Suspended";
        break;
      case 4:
        status = "Closed";
        break;
      case 9:
        status = "Ball Start";
        break;
      default:
        status = "";
    }
    return status;
  },
  getSportType: (t) => {
    var type = "";
    switch (t) {
      case 1:
        type = "soccer";
        break;
      case 2:
        type = "tennis";
        break;
      case 4:
        type = "cricket";
        break;

      default:
        type = "";
    }
    return type;
  },
  isInputNumber: (event) => {
    var char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  },
  truncateDecimals: (num, digits) => {
    var numS = num.toString(),
      decPos = numS.indexOf("."),
      substrLength = decPos == -1 ? numS.length : 1 + decPos + digits,
      trimmedResult = numS.substr(0, substrLength),
      finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;

    return parseFloat(finalResult);
  },
};

export default obj;
